import {ButtonVariant} from "@/app/_components/Button";
import LinkButton from "@/app/_components/LinkButton";

const ConsultationRequiredModalBody = () => {
	return (
		<div className="flex max-w-lg flex-col gap-4 p-8 pt-12">
			<h3 className="text-h4">Request a Consultation</h3>
			<p>
				Taking this course requires a consultation and evaluation. You must be
				approved to enroll in this course.
			</p>
			<LinkButton
				id="add-class-modal-request-consultation-button"
				className="mt-2 max-w-64 self-center text-sm"
				variant={ButtonVariant.NAVY}
				href="/contact-us"
			>
				REQUEST CONSULTATION
			</LinkButton>
		</div>
	);
};

export default ConsultationRequiredModalBody;
